import { UserProfile } from 'api/account/models/UserProfile';
import { CatalogSupplierSearchCriteria } from 'api/catalog/models/CatalogSupplierSearchCriteria';
import ChargesService from 'api/charges/ChargesService';
import { ChargeDto, ChargeGeofenceDto } from 'api/charges/models/ChargeDto';
import { ChargeValidationWarning } from 'common/components/chargeValidation/models';
import { parseWarnings } from 'common/components/chargeValidation/ChargeValidationService';
import ChargeValidationWarningList from 'common/components/chargeValidation/ChargeValidationWarningList';
import ChargeValidationJustifyModal from 'common/components/chargeValidation/ChargeValidationJustifyModal';
import GenericTypesService from 'api/genericTypes/GenericTypesService';
import { SelectValueGenericTypeDto } from 'api/genericTypes/models/SelectValueGenericTypeDto';
import SuppliersService from 'api/suppliers/SuppliersService';
import { UsersSelectItemDto } from 'api/users/models/UserDto';
import UsersService from 'api/users/UsersService';
import VehiclesService from 'api/vehicles/VehiclesService';
import IconBack from 'assets/svg/Arrow-grey.svg';
import Box from 'common/components/box/Box';
import Button from 'common/components/button/Button';
import CheckBox from 'common/components/checkBox/CheckBox';
import DateTimePickerController from 'common/components/dateTimePicker/DateTimePickerController';
import FileSelector from 'common/components/fileSelector/FileSelector';
import FormItem from 'common/components/formItem/FormItem';
import InputController from 'common/components/input/InputController';
import InputError from 'common/components/inputError/InputError';
import InputGroup from 'common/components/inputGroup/InputGroup';
import InputGroupController from 'common/components/inputGroup/InputGroupController';
import Label from 'common/components/label/Label';
import QuestionYesNo from 'common/components/questionYesNo/QuestionYesNo';
import ScreenTitle from 'common/components/screenTitle/ScreenTitle';
import Select from 'common/components/select/Select';
import SelectController from 'common/components/select/SelectController';
import CustomFile from 'common/models/CustomFile';
import Loading from 'common/services/Loading';
import Logger from 'common/services/Logger';
import Utils from 'common/services/Utils';
import { SelectValueLabel } from 'common/types/SelectValueLabel';
import { DATE_FORMAT_DEFAUT, DEFAULT_INPUT_RULES, DEFAULT_INPUT_RULES_WITH_REQUIRED, FUELS, LOGGER_LOG_TYPE, SEGMENT_FEATURES } from 'Config';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-flexbox-grid';
import { Controller, useFieldArray, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FaCalendarAlt } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { useToasts } from 'react-toast-notifications';
import { Reducers } from 'store/types';
import styles from './ChargeScreen.module.scss';
import TimeLine, { TimeLineItem } from 'common/components/timeLine/TimeLine';
import InputResizableController from 'common/components/input/InputResizableController';
import { ChargesStatusColorEnum } from 'api/charges/enums/ChargesStatusColorEnum';
import ReactTooltip from 'react-tooltip';
import DateTimePickerControllerNew from 'common/components/dateTimePicker/DateTimePickerControllerNew';
import { VehicleDto } from 'api/vehicles/models/VehicleDto';
import InputInfoWarning from 'common/components/inputInfoWarning/InputInfoWarning';
import TrackingService from 'api/tracking/TrackingService';
import { TrackingProvider } from 'api/tracking/enums/TrackingProvider';
import ChargeGeofenceForm from './chargeGeofenceForm/ChargeGeofenceForm';
import GeofencesService from 'api/geofences/GeofencesService';
import { CompactPageLayout } from 'common/components/compactPageLayout';
import DateFormat from 'common/components/dateFormat/dateFormat';


export enum SituationType {
    TREATED = 'TREATED',
    NOT_TREATED = 'NOT_TREATED',
}

export enum RequestStatusType {
    APPROVED = 'APPROVED',
    REFUSED = 'REFUSED',
    PENDING = 'PENDING',
    NONE = 'NONE'
}


export type Props = {
    isVehicle?: boolean;
    isDriver?: boolean;
    onBackList: () => void;
} & React.DetailedHTMLProps<React.LabelHTMLAttributes<HTMLDivElement>, HTMLDivElement>;

const ChargeScreen = ({ isVehicle, isDriver, onBackList, ...props }: Props) => {
    const { t } = useTranslation();
    const { addToast } = useToasts();
    const history = useHistory();
    // eslint-disable-next-line
    let { vehicleId, driverId, itemType, itemId, tabId, type } = useParams<{ vehicleId: string, driverId: string, itemType: string, itemId: string, tabId: string, type: string }>();
    const [itemToRemove, setItemToRemove] = useState<ChargeDto>();
    const [dialogDeleteItemIsOpen, setDialogDeleteItemIsOpen] = React.useState(false);
    const [charge, setCharge] = useState<ChargeDto | null>(null);

    const [vehicleOptions, setVehicleOptions] = useState<SelectValueLabel[]>([]);
    const [typeOptions, setTypeOptions] = useState<SelectValueGenericTypeDto[]>([]);
    const [allTypeOptions, setAllTypeOptions] = useState<SelectValueGenericTypeDto[]>([]);
    const [supplierOptions, setSupplierOptions] = useState<SelectValueLabel[]>([]);
    const [responsibleOptions, setResponsibleOptions] = useState<SelectValueLabel[]>([]);
    const [selectecType, setSelectecType] = useState<SelectValueGenericTypeDto>();
    const [selectedRefundTreated, setSelectedRefundTreated] = useState<boolean | null>(null);
    const [selectedRequestRefund, setSelectedRequestRefund] = useState<boolean>(false);
    const [fuelOptions, setFuelOptions] = useState<SelectValueLabel[]>([]);
    const [geofencesOptions, setGeofencesOptions] = useState<SelectValueLabel[]>([]);
    const [reRender, setReRender] = useState<number>(0);
    const [requiredFields, setRequiredFields] = useState<string[]>([]);
    const [displayFields, setDisplayFields] = useState<string[]>([]);
    const [vehicle, setVehicle] = useState<VehicleDto | undefined>(undefined);
    const [inputKmsBelowCurrentVehicleKms, setInputKmsBelowCurrentVehicleKms] = useState<boolean>(false);
    const [currentKms, setCurrentKms] = useState<number | null>(null);

    const [attachmentsRequired, setAttachmentsRequired] = useState<boolean | undefined>(undefined);

    // Task #66078: justification modal shown when the server-side validation returns warnings.
    // Task #66220: passou a reutilizar o modal partilhado com a importação (avisos por bullets).
    const [justificationModal, setJustificationModal] = useState<{
        warnings: ChargeValidationWarning[];
        savedJustification: string;
        submit: (justification: string) => void;
        cancel: () => void;
    } | null>(null);

    const demandStatusOptions: SelectValueLabel[] = [
        { value: RequestStatusType.PENDING, label: t(('charges.request_status_type.' + RequestStatusType.PENDING) as any) },
        { value: RequestStatusType.APPROVED, label: t(('charges.request_status_type.' + RequestStatusType.APPROVED) as any) },
        { value: RequestStatusType.REFUSED, label: t(('charges.request_status_type.' + RequestStatusType.REFUSED) as any) }
    ];

    const [blockRefundTreated, setBlockRefundTreated] = useState<boolean>(false);

    const [savedFiles, setSavedFiles] = useState<CustomFile[]>([]);
    const [refundSavedFiles, setRefundSavedFiles] = useState<CustomFile[]>([]);


    const form = useForm<ChargeDto>({ shouldUnregister: false, defaultValues: {} });
    const { handleSubmit, getValues, setValue, control, errors, reset } = form;

    const userProfile = useSelector<Reducers, UserProfile | null>(state => state.authentication.profile);
    const hasChargesWritePolicy = UsersService.hasPolicies(userProfile?.policies || [], ['SETTINGUP_CHARGES_WRITE']);
    const hasWriteRefundStatusPolicy = UsersService.hasPolicies(userProfile?.policies || [], ['SETTINGUP_REFUND_STATUS_WRITE']);
    const hasWriteRefundSituationPolicy = UsersService.hasPolicies(userProfile?.policies || [], ['SETTINGUP_REFUND_SITUATION_WRITE']);
    const hasReadRefundPolicy = UsersService.hasPolicies(userProfile?.policies || [], ['SETTINGUP_REFUND_READ']);
    const hasReadGPSKmsPolicy = UsersService.hasPolicies(userProfile?.policies || [], ['SETTINGUP_GPS_KMS_READ']);
    const hasReadCostCenterPolicy = UsersService.hasPolicies(userProfile?.policies || [], ['SETTINGUP_COST_CENTER_READ']);

    const [refundHistory, setRefundHistory] = useState<TimeLineItem[]>([]);
    const [refreshKey, setRefreshKey] = useState<number>(new Date().getTime());

    const [isRefundSavedApprovedOrRefused, setIsRefundSavedApprovedOrRefused] = useState<boolean>(false);
    let refundPayed = form.watch('refund.situation') == SituationType.TREATED;

    const geofences = useFieldArray<ChargeGeofenceDto>({ control: form.control, name: 'geofences', keyName: 'formId' as any });
    
    const refresh = () => {
        setRefreshKey(new Date().getTime());
    }

    const getData = async () => {

        setValue('attachmentsToRemove', []);
        try {
            Loading.show();

            const types1 = await (itemId ? GenericTypesService.catalogChargeByChargeId(itemId) : GenericTypesService.catalogCharge());
            const types2 = types1.map(x => ({ ...x, name: x.label, label: x.isSystem ? t(`common.generic_types.${x.label}` as any) : x.label }));
            const types = Utils.sortAlphabetically(types2);
            setTypeOptions(types);
            setAllTypeOptions(types);

            const responsables = await UsersService.getAllForCompany();
            const responsibleOpts = (responsables || []).map((x: UsersSelectItemDto) => ({ value: x.id || '', label: x.realName || '' }));
            setResponsibleOptions(responsibleOpts);

            if (Utils.isStringNullOrEmpty(vehicleId) && !itemId) {
                const vehicles = await VehiclesService.catalog();
                setVehicleOptions(vehicles);
            }

            if (hasReadCostCenterPolicy) {
                const geofences = await GeofencesService.catalog();
                setGeofencesOptions(geofences);
            }

            let vehicleIdVerified = vehicleId;
            if (itemId) {
                const result = await ChargesService.getById(itemId);
                if (result === undefined) {
                    addToast(t('common.messages.error_load_info'), { appearance: 'error' });
                    Logger.error(LOGGER_LOG_TYPE.CHARGES, `Couldn't get the charge with id: ${itemId}`);
                    history.goBack();
                }
                const vehicles = await VehiclesService.catalog({ vehicleId: result.vehicleId ?? null });
                setVehicleOptions(vehicles);

                // condutor/operador eliminado: manter a opção no select para não desaparecer do detalhe nem se perder ao guardar
                if (result?.responsibleId && !responsibleOpts.find(x => x.value === result.responsibleId)) {
                    setResponsibleOptions([...responsibleOpts, { value: result.responsibleId, label: result.responsibleName || '' }]);
                }

                vehicleIdVerified = !vehicleIdVerified ? (result.vehicleId ?? '') : vehicleIdVerified;
                setValues(result, types);

                getVehicle((result.vehicleId ?? ''), result);

            } else {
                // Meia-noite local (não o instante atual): a data da despesa é dia-só e a hora
                // espúria acabava gravada em UTC, podendo cair no dia/mês errado nos acumulados.
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                setValue('date', today);

                if (!Utils.isStringNullOrEmpty(vehicleIdVerified)) {
                    getVehicle(vehicleId);
                }
            }


            refresh();

            Loading.hide();
        } catch (error) {
            Logger.error(LOGGER_LOG_TYPE.CHARGES, `Couldn't get information to create charge`, error);
            addToast(t('common.messages.error_load_info'), { appearance: 'error' });
        }
    }

    const setValues = (values: ChargeDto, types: SelectValueGenericTypeDto[]) => {
        const refundHistories = values.refundHistory.map((x, i) => {
            let approvedAndPayed = false;
            let approvedAndNotPayed = false;
            //if it was approved and payed in the same save
            if (x.situation && x.situation == SituationType.TREATED && (values.refundHistory[i + 1] == undefined || values.refundHistory[i + 1].status !== RequestStatusType.APPROVED)) {
                approvedAndPayed = true
            }
            //if it was approved and not payed in the same save - default
            if ((x.situation == SituationType.NOT_TREATED || !x.situation)) {
                approvedAndNotPayed = true
            }
            return ({
                ...x,
                title: x.status && (!x.situation || x.situation == SituationType.NOT_TREATED) ?
                    <> <span className={styles.labelHistory} style={{ color: x.status == RequestStatusType.REFUSED ? (ChargesStatusColorEnum as any)[x.status] : 'black' }}> {t(('charges.request_status_type.' + x.status) as any)}</span>  </>
                    :
                    x.situation ?
                        <> <span className={styles.labelHistory} style={{ color: (!approvedAndNotPayed || approvedAndPayed) ? (ChargesStatusColorEnum as any)[x.situation] : 'black' }}>
                            {
                                approvedAndPayed ? t(('charges.approved_and_payed')) : approvedAndNotPayed ? t(('charges.request_status_type.APPROVED')) :
                                    t(('charges.situations.' + x.situation) as any)
                            }</span> </>
                        : '',
                date: x.updatedDate ?? x.createdDate,
                dateRefund: x.dateRefundTreated,
                userName: x.userCreatedHistoryName,
                description: x.observations,
                status: x.status,
                situation: x.situation
            })
        });
        values.refund = refundHistories && refundHistories.length ? refundHistories[0] : undefined;
        if (values.refund) {
            values.refund.observations = undefined;
            setValue('refund.observations', undefined);
        }
        values.paymentDate = values.paymentDate ? new Date(values.paymentDate) : undefined;
        if (values.refund && values.refund.status == RequestStatusType.APPROVED && values.refund.situation == null) {
            values.refund.situation = SituationType.NOT_TREATED;
        }
        reset({ ...values, date: new Date(values.date) });
        setCharge(values);

        getSupplierByType(values.typeId);
        setSelectedRequestRefund(values.requestRefund);

        const type = types.find(x => x.value == values.typeId);

        setRequiredFields(type ? (type.requiredFieldsList ?? []) : [])
        setDisplayFields(type ? (type.displayFieldsList ?? []) : [])

        setBlockRefundTreated(!Utils.isStringNullOrEmpty(values.fuelCard ?? ''));

        setValuesFiles(values.chargeAttachments);

        setSelectedRefundTreated(values.refund?.situation == null ? null
            : (values.refund?.situation == SituationType.TREATED) ? true : false);

        setRefundHistory(refundHistories);

        setIsRefundSavedApprovedOrRefused(values.refund?.status == RequestStatusType.APPROVED || values.refund?.status == RequestStatusType.REFUSED);
        refundPayed = values.refund?.situation == SituationType.TREATED;
        setReRender(reRender + 1);
    }

    const showField = (feature: string) => {
        return (vehicle?.segmentFeatures?.findIndex(x => x == feature) ?? -1) >= 0;
    }

    const roundToTwoDecimals = (num: number) => Math.round(num * 100) / 100;

    // Task #66078: actual persistence step, deferred until the justification modal is confirmed
    // (or run immediately when there are no warnings / the validation call failed).
    const persistCharge = async (form: ChargeDto) => {
        try {
            Loading.show();

            form.attachments = prepareFilesToSubmit();

            // convencao: liters >= 1 mesmo para tipos sem campo visivel (consistencia com o flow de import)
            if (form.liters == null) form.liters = 1;

            if (form.id) {
                await ChargesService.update(form, form.attachments ? form.attachments : [])
            } else {
                itemId = await ChargesService.create(form, form.attachments ? form.attachments : [])
            }

            Loading.hide();
            addToast(t('common.messages.record_save_success'), { appearance: 'success' });

            getData();

            if ((isVehicle || isDriver) && onBackList) {
                onBackList();
                return;
            }
            history.goBack();
        } catch (error) {
            addToast(t('common.messages.record_save_error'), { appearance: 'error' });
            Logger.error(LOGGER_LOG_TYPE.CHARGES, `Couldn't update the charge with id: ${form.id}`, error);
            arrangeFilesAfterSubmit();
            Loading.hide();
        }
    }

    const onSubmit = async (form: ChargeDto) => {

        if (attachmentsRequired && !form.chargeAttachments?.length) {
            addToast(t('charges.attachment_required'), { appearance: 'warning' });
            return;
        }

        const percentage = roundToTwoDecimals(form && form.geofences ? (form.geofences.reduce((sum, item) => sum + item.percentage, 0)) : 0);

        if (percentage > 100) {
            addToast(t('common.errors.max_percentage_100'), { appearance: 'warning' });
            return;
        }

        form.vehicleId = Utils.isStringNullOrEmpty(vehicleId) ? form.vehicleId : vehicleId;

        if (form.refund && charge?.refund) {
            if (form.refund.status != charge?.refund.status && form.refund.situation == charge?.refund.situation) {
                form.refund.situation = undefined;
                form.refund.dateRefundTreated = undefined;
            }
        } else if (!form.refund?.status && !form.refund?.situation) {
            form.refund = undefined;
        }

        // Task #66078: validate server-side (kms decrease, daily-km limit, tank/battery capacity,
        // duplicates). If warnings, require a justification before saving. On failure, don't block.
        try {
            Loading.show();
            const results = await ChargesService.validate({
                id: form.id,
                vehicleId: form.vehicleId,
                date: form.date,
                cost: form.cost,
                liters: form.liters,
                kilometers: form.kilometers,
                fuelId: form.fuelId,
            });
            Loading.hide();

            const warnings = results?.[0]?.warnings ?? [];
            if (warnings.length > 0) {
                setJustificationModal({
                    warnings,
                    // Em edição, pré-preenche com a justificação já gravada para o user manter ou editar.
                    savedJustification: charge?.validationJustification ?? '',
                    // "Gravar mesmo assim": persist including justification + accepted warnings.
                    submit: (justification: string) => {
                        form.validationJustification = justification;
                        form.validationWarnings = JSON.stringify(warnings);
                        persistCharge(form);
                    },
                    // "Corrigir agora": abort the save and stay in the form.
                    cancel: () => { /* keep the form open, do not save */ },
                });
                return;
            }
        } catch (error) {
            Loading.hide();
            Logger.error(LOGGER_LOG_TYPE.CHARGES, `Couldn't validate the charge with id: ${form.id}`, error);
            // do not block the save when validation is unavailable
        }

        persistCharge(form);
    }

    const showRemoveItemDialog = (item: ChargeDto) => {
        setItemToRemove(item);
        setDialogDeleteItemIsOpen(true);
    };

    const removeItem = async () => {
        setDialogDeleteItemIsOpen(false);
        if (!!itemToRemove) {
            try {
                Loading.show();
                await ChargesService.remove(itemToRemove);
                addToast(t('common.messages.record_delete_success'), { appearance: 'success' });

                if ((isVehicle || isDriver) && onBackList) {
                    onBackList();
                    return;
                }
                history.goBack();
                Loading.hide();
            } catch (error) {
                addToast(t('common.messages.record_delete_error'), { appearance: 'error' });
                Loading.hide();
            }
        }
    };

    const getSupplierByType = async (typeId: string) => {
        try {
            Loading.show();
            let options: SelectValueLabel[] = [];
            if (typeId) {
                const suppliers = await SuppliersService.catalog({ typeId: typeId } as CatalogSupplierSearchCriteria);
                options = (suppliers || []).map((x: SelectValueLabel) => ({ value: x.value || '', label: x.label || '' }));
            }

            if (getValues('supplierId') && !options.find(x => x.value === getValues('supplierId'))) {
                if (Utils.isStringNullOrEmpty(itemType) ? type === 'details' : itemType === 'details') {
                    options.push({ value: getValues('supplierId') ?? '', label: getValues('supplierName') ?? '' })
                } else {
                    setValue('supplierId', null);
                }
            }

            setSupplierOptions(options);

        } catch (error) {
            Logger.error(LOGGER_LOG_TYPE.CHARGES, `Couldn't get supplier by type`, error);
            addToast(t('common.messages.error_load_info'), { appearance: 'error' });
        }
        finally {
            Loading.hide();
        }
    }

    const navigateTo = (typeUrl?: string, id?: string) => {
        if (typeUrl) {
            history.push(`/charges/${typeUrl}/${id}`);
        } else {
            history.goBack();
            //history.push(`/charges`);
        }
    }

    const getHeaderTitle = () => {
        if (type === 'new') return t('charges.new');
        if (type === 'edit') return t('charges.edit');
        if (type === 'details') return t('charges.details');
        return t('charges.title');
    };

    const onSelectRefundTreated = (mode: boolean, typeSituation?: SituationType) => {
        setSelectedRefundTreated(mode);

        setValue('refund.situation', typeSituation);
        setValue('refund.dateRefundTreated', (!mode) ? null : new Date());
    }

    const onchangeRequestRefund = (mode: boolean) => {
        setSelectedRequestRefund(mode);
        setSelectedRefundTreated(null);
        setValue('refundTreated', selectedRefundTreated);
        setValue('dateRefundTreated', mode ? new Date() : null);

        if (mode) {
            setValue('refund.status', RequestStatusType.PENDING);
        }
    }

    const getFuelCard = async (id: string) => {
        try {
            const result = await VehiclesService.getById(id);
            let fuelCard = null;
            if (result) {
                fuelCard = result.fuelCard;
                setValue('supplierId', result.fuelCardSupplierId);
            }
            setValue('fuelCard', fuelCard ?? '');
            setBlockRefundTreated(!!fuelCard ? true : false);

        } catch (error) {
            Logger.error(LOGGER_LOG_TYPE.MAINTENANCE_CONTRACTS, `Couldn't get information to use contract associate`, error);
            addToast(t('common.messages.error_load_info'), { appearance: 'error' });
        }
    }

    const changeFuelCard = () => {
        const fuelCardAux = getValues('fuelCard');
        if (fuelCardAux != null && fuelCardAux != '') {
            setSelectedRequestRefund(false);
            onSelectRefundTreated(false);
            setValue('requestRefund', false);
            setBlockRefundTreated(true);
        } else {
            setBlockRefundTreated(false);
        }
    }

    const changeType = (data: SelectValueGenericTypeDto) => {
        form.clearErrors();
        setValue('typeId', data ? data.value : null);

        setSelectecType(data);
        setRequiredFields(data ? (data.requiredFieldsList ?? []) : [])
        if (data) {
            data.displayFieldsList = (data.displayFieldsList?.filter(field => field !== 'SUPPLIER' || data.isSupplier) ?? []);
        }
        setDisplayFields(data ? (data.displayFieldsList ?? []) : [])
        // current kms from tracking
        getGpsKms();
        setAttachmentsRequired(data?.attachmentRequired);
    }

    const onRemoveFile = (file: CustomFile) => {
        if (file.id) {
            const arr = [...(getValues('attachmentsToRemove') || []), file.id];
            setValue('attachmentsToRemove', arr);
        }
    }
    const changeVehicle = async (data: SelectValueLabel) => {
        const vId = data ? data.value : null;
        setValue('vehicleId', vId);
        const newVehicle = await getVehicle(vId);

        const currentTypeId = getValues('typeId');
        if (!currentTypeId) return;

        const currentType = allTypeOptions.find(x => x.value === currentTypeId);
        if (currentType?.name === 'FUEL' && newVehicle?.segmentFeatures && !newVehicle.segmentFeatures.includes('FUEL')) {
            setValue('fuelId', null);
            setValue('liters', null as any);
            changeType(null as any);
        }
    }

    const arrangeFilesAfterSubmit = () => {
        setValuesFiles(savedFiles);
        setValuesRefundFiles(refundSavedFiles);
    }

    const prepareFilesToSubmit = () => {
        setValuesFiles(getValues('attachments')?.filter(x => !x.id));

        const attachments = getValues('chargeAttachments')?.filter(x => !x.id) ?? [];
        const refundAttachments = getValues('refundAttachments')?.filter(x => !x.id) ?? []

        const fullAttachments = [...attachments, ...refundAttachments];
        setValue('attachments', fullAttachments);
        return fullAttachments;
    }

    const setValuesFiles = (files: CustomFile[]) => {
        if (files && files.length > 0) {
            files.map(x => x.containerName = 'CHARGE');
            setValue('chargeAttachments', files);
            setSavedFiles(files?.filter(x => x.id));
        }

    }
    const setValuesRefundFiles = (files: CustomFile[]) => {
        if (files && files.length > 0) {
            files.map(x => x.containerName = 'REFUND');
            setValue('refundAttachments', files);
            setRefundSavedFiles(files?.filter(x => x.id));
        }
    }
    useEffect(() => {
        getData();
    }, []);

    useEffect(() => {
        if (vehicle && ((!!type && type !== 'details') || (!!itemType && itemType !== 'details'))) {
            // current kms from tracking
            getGpsKms();
        }
    }, [vehicle, type, itemType]);

    useEffect(() => {
        if (vehicle && !itemId && ((!!type && type == 'new') || (!!itemType && itemType == 'new'))) {
            setKilometers();
            setHours();
        }
    }, [displayFields, vehicle, currentKms, type]);


    useEffect(() => {

        if (shouldDisplay('CARD')) {
            vehicleId && getFuelCard(vehicleId);
        } else {
            setValue('fuelCard', null);
            setBlockRefundTreated(false);
        }

        if (shouldDisplay('SUPPLIER') && selectecType) {
            getSupplierByType(selectecType?.value);
        } else {
            setValue('supplierId', null);
        }
    }, [selectecType]);

    useEffect(() => {
        if (vehicle?.segmentFeatures && !showField('FUEL')) {
            setTypeOptions(allTypeOptions.filter(x => x.name != 'FUEL'));
        } else {
            setTypeOptions(allTypeOptions);
        }
    }, [vehicle, allTypeOptions]);




    const isRequired = (field: string) => {
        return requiredFields.includes(field);
    }

    const shouldDisplay = (field: string) => {
        return displayFields.includes(field);
    }

    const getVehicle = async (id?: string | null, chargeAux?: ChargeDto): Promise<VehicleDto | undefined> => {
        try {
            const _vehicle = id ? await VehiclesService.getById(id) : undefined

            setVehicle(_vehicle);

            if (_vehicle) {
                let aux = _vehicle?.vehicleFuels?.map(x => {
                    return {
                        value: x.fuelId,
                        label: !!x.fuelName ? t(('vehicle.fuels.' + x.fuelName) as any) : '',
                        fullLabel: (x.fuelName ?? ''),
                    }
                }) ?? [];

                if (chargeAux && !!chargeAux.fuelId && !aux.find(x => x.value == chargeAux.fuelId)) {
                    aux.push({ value: chargeAux.fuelId, fullLabel: (chargeAux.fuelName ?? ''), label: !!chargeAux.fuelName ? t(('vehicle.fuels.' + chargeAux.fuelName) as any) : '' });
                    aux = Utils.sortAlphabetically(aux);
                }

                setFuelOptions(aux);

                if (itemType == 'new' && aux.length == 1) {
                    form.setValue('fuelId', aux[0].value);
                }
            }

            if (itemId && _vehicle && (form.watch('kilometers') ?? 0) < (_vehicle?.currentKilometers ?? 0)) {
                setInputKmsBelowCurrentVehicleKms(true);
            } else {
                setInputKmsBelowCurrentVehicleKms(false);
            }

            return _vehicle;
        } catch (error) {
            Logger.error(LOGGER_LOG_TYPE.CHARGES, `Couldn't get vehicle data`, error);
            addToast(t('common.messages.error_load_info'), { appearance: 'error' });
            return undefined;
        }
    }

    const getGpsKms = async () => {
        if (vehicle && vehicle.id && vehicle.companyTrackingProvider && vehicle?.companyTrackingProvider !== TrackingProvider.NONE && vehicle.trackingDeviceId) {
            try {
                const positionResult = await TrackingService.getGpsVehiclesPosition([vehicle.id]);
                if (positionResult && positionResult.length > 0) {
                    setCurrentKms(positionResult[0]?.km ?? null);
                }
            } catch (error) {
                Logger.error(LOGGER_LOG_TYPE.CHARGES, `Couldn't get vehicle gps kms`, error);
                addToast(t('common.messages.error_load_info'), { appearance: 'error' });
            }
        }
    }

    const setKilometers = () => {
        if (vehicle && shouldDisplay('KMS') && showField(SEGMENT_FEATURES.KM)) {
            if (hasReadGPSKmsPolicy && currentKms != null) {
                form.setValue('kilometers', currentKms);
                return;
            }
            form.setValue('kilometers', vehicle?.currentKilometers);
            return;
        } else if (!shouldDisplay('KMS') || !showField(SEGMENT_FEATURES.KM)) {
            form.setValue('kilometers', undefined);
            return
        }
        form.setValue('kilometers', undefined);

    }

    const setHours = () => {
        if (vehicle && showField(SEGMENT_FEATURES.HOURS)) {
            form.setValue('hours', vehicle?.currentHours ?? undefined);
            return;
        }
        form.setValue('hours', undefined);
    }

    const compareKms = () => {
        if (vehicle && (form.watch('kilometers') ?? 0) < (vehicle?.currentKilometers ?? 0)) {
            setInputKmsBelowCurrentVehicleKms(true);
            return;
        }
        setInputKmsBelowCurrentVehicleKms(false);
    }

    // Task #66078: on the details view, show the justification + accepted warnings (who/when) if any.
    const renderValidationDetails = () => {
        const isDetailsView = Utils.isStringNullOrEmpty(itemType) ? type === 'details' : itemType === 'details';
        if (!isDetailsView || !charge?.validationJustification) return <></>;

        const warnings = parseWarnings(charge.validationWarnings);
        const auditDate = charge.updatedDate ?? charge.createdDate;

        return (
            <Row>
                <Col xs={12}>
                    <FormItem>
                        <div style={{ background: '#fef3c7', borderLeft: '4px solid #E2B434', borderRadius: 4, padding: '12px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 16 }}>
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <div><strong>{t('charges.validation.justification_label')}:</strong> {charge.validationJustification}</div>
                                {warnings.length > 0 &&
                                    <div style={{ margin: '6px 0 0', color: '#8a6d1b' }}>
                                        <ChargeValidationWarningList rows={[{ line: 0, warnings }]} />
                                    </div>}
                            </div>
                            {(charge.userCreatedName || auditDate) &&
                                <div style={{ textAlign: 'right', fontSize: '0.8rem', color: '#8a7320', whiteSpace: 'nowrap', flexShrink: 0 }}>
                                    {charge.userCreatedName ? <div>{t('charges.validation.accepted_by')}: <strong>{charge.userCreatedName}</strong></div> : <></>}
                                    {auditDate ? <div><DateFormat value={auditDate} format={DATE_FORMAT_DEFAUT} /></div> : <></>}
                                </div>}
                        </div>
                    </FormItem>
                </Col>
            </Row>
        );
    };

    const renderBody = () => {
        return (
            <>
                <Row>
                    {((isRefundSavedApprovedOrRefused) && Boolean(charge)) &&
                        <div className={styles.messageRefundApproved}>
                            <span className={styles.labelRefundApproved}>{t('charges.charge_has_refund_approved')}</span>
                        </div>}
                </Row>
                {renderValidationDetails()}
                <Row>
                    {!isVehicle &&
                        <Col xs={12} md={6} lg={4}>
                            <FormItem>
                                <Label className={styles.label}>{t('vehicle.vehicle')} {Utils.isStringNullOrEmpty(itemType) ? type !== 'details' ? '*' : '' : itemType !== 'details' ? '*' : ''}</Label>
                                <SelectController
                                    form={form}
                                    isDisabled={(Utils.isStringNullOrEmpty(itemType) ? type === 'details' : itemType === 'details') || (isRefundSavedApprovedOrRefused && Boolean(charge))}
                                    placeholder={t('vehicle.vehicle')}
                                    name="vehicleId"
                                    options={vehicleOptions}
                                    rules={{ required: true }}
                                    onChangeSelect={(data: SelectValueLabel) => {
                                        changeVehicle(data);
                                    }} />
                                <InputError error={errors.vehicleId} />
                            </FormItem>
                        </Col>}
                    <Col xs={12} md={6} lg={4}>
                        <FormItem>
                            <Label className={styles.label}>{t('charges.charge_date')} {Utils.isStringNullOrEmpty(itemType) ? type !== 'details' ? '*' : '' : itemType !== 'details' ? '*' : ''}</Label>
                            <DateTimePickerController
                                form={form}
                                placeholderText={t('charges.charge_date')}
                                onChange={(date: Date) => {
                                    setValue('date', date);
                                    setCharge(charge ? { ...charge, date: date } : null);
                                }}
                                selected={charge ? moment(charge.date).toDate() : null}
                                dateFormat={DATE_FORMAT_DEFAUT}
                                customInput={<InputGroup icon={<FaCalendarAlt />} />}
                                name="date"
                                autoComplete='off'
                                disabled={(Utils.isStringNullOrEmpty(itemType) ? type === 'details' : itemType === 'details') || (isRefundSavedApprovedOrRefused && Boolean(charge))}
                                rules={{ required: true }} />
                            <InputError error={errors.date} />
                        </FormItem>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <FormItem>
                            <Label className={styles.label}>{t('charges.charge_type')} {Utils.isStringNullOrEmpty(itemType) ? type !== 'details' ? '*' : '' : itemType !== 'details' ? '*' : ''}</Label>
                            <Controller
                                render={({ onChange, value, ref }) => {
                                    return (
                                        <Select
                                            options={typeOptions}
                                            isClearable
                                            isDisabled={(Utils.isStringNullOrEmpty(itemType) ? type === 'details' : itemType === 'details') || (isRefundSavedApprovedOrRefused && Boolean(charge))}
                                            placeholder={t('common.type')}
                                            onChange={(data: SelectValueGenericTypeDto) => {
                                                onChange(data?.value ?? null);
                                                changeType(data ?? null);
                                            }}
                                            ref={ref}
                                            value={typeOptions.find(x => x.value === value) ? { label: typeOptions.find(x => x.value === value)?.label ?? '', value: value } : null}
                                        />
                                    );
                                }}
                                control={control}
                                name="typeId"
                                defaultValue={getValues('typeId')}
                                rules={{ required: true }} />
                            <InputError error={errors.typeId} />
                        </FormItem>
                    </Col>

                    {shouldDisplay('FUEL') && <Col xs={12} md={6} lg={4}>
                        <FormItem>
                            <Label className={styles.label}>{t('vehicle.fuel')} {(Utils.isStringNullOrEmpty(itemType) ? type !== 'details' : itemType !== 'details') && isRequired('SUPPLIER') ? '*' : ''}</Label>
                            <SelectController
                                form={form}
                                isDisabled={(Utils.isStringNullOrEmpty(itemType) ? type === 'details' : itemType === 'details') || (isRefundSavedApprovedOrRefused && Boolean(charge))}
                                placeholder={t('vehicle.fuel')}
                                name="fuelId"
                                options={fuelOptions}
                                isClearable={true}
                                rules={{ required: isRequired('FUEL') }}
                                onChange={() => {
                                    setReRender(reRender + 1);
                                }}
                            />
                            {isRequired('FUEL') && <InputError error={errors.fuelId} />}
                        </FormItem>
                    </Col>}


                    {shouldDisplay('SUPPLIER') && <Col xs={12} md={6} lg={4}>
                        <FormItem>
                            <Label className={styles.label}>{t('common.supplier')} {(Utils.isStringNullOrEmpty(itemType) ? type !== 'details' : itemType !== 'details') && isRequired('SUPPLIER') ? '*' : ''}</Label>
                            <SelectController
                                form={form}
                                isDisabled={(Utils.isStringNullOrEmpty(itemType) ? type === 'details' : itemType === 'details') || (isRefundSavedApprovedOrRefused && Boolean(charge))}
                                placeholder={t('common.supplier')}
                                name="supplierId"
                                isClearable={true}
                                options={supplierOptions}
                                rules={{ required: isRequired('SUPPLIER') }} />
                            {isRequired('SUPPLIER') && <InputError error={errors.supplierId} />}
                        </FormItem>
                    </Col>}
                    {shouldDisplay('CARD') && <Col xs={12} md={6} lg={4}>
                        <FormItem>
                            <Label className={styles.label}>{t('vehicle.fuel_card')} {(Utils.isStringNullOrEmpty(itemType) ? type !== 'details' : itemType !== 'details') && isRequired('CARD') ? '*' : ''}</Label>
                            <InputController
                                name="fuelCard"
                                form={form as any}
                                autoComplete='off'
                                disabled={(Utils.isStringNullOrEmpty(itemType) ? type === 'details' : itemType === 'details') || (isRefundSavedApprovedOrRefused && Boolean(charge))}
                                placeholder={t('vehicle.fuel_card')}
                                rules={isRequired('CARD') ? { ...DEFAULT_INPUT_RULES_WITH_REQUIRED } : { ...DEFAULT_INPUT_RULES }}
                                onKeyUp={changeFuelCard} />
                            {isRequired('CARD') && <InputError error={errors.fuelCard} />}
                        </FormItem>
                    </Col>}
                    {shouldDisplay('DESCRIPTION') && <Col xs={12} md={6} lg={4}>
                        <FormItem>
                            <Label className={styles.label}>{t('charges.description')} {(Utils.isStringNullOrEmpty(itemType) ? type !== 'details' : itemType !== 'details') && isRequired('DESCRIPTION') ? '*' : ''}</Label>
                            <InputController
                                name="description"
                                form={form as any}
                                autoComplete='off'
                                disabled={(Utils.isStringNullOrEmpty(itemType) ? type === 'details' : itemType === 'details') || (isRefundSavedApprovedOrRefused && Boolean(charge))}
                                placeholder={t('charges.description')}
                                rules={isRequired('DESCRIPTION') ? { ...DEFAULT_INPUT_RULES_WITH_REQUIRED, maxLength: 999 } : { ...DEFAULT_INPUT_RULES, maxLength: 999 }}
                            />
                            {isRequired('DESCRIPTION') && <InputError error={errors.description} />}
                        </FormItem>
                    </Col>}
                    <Col xs={12} md={6} lg={4}>
                        <FormItem>
                            <Label className={styles.label}>{t('common.responsible')} {Utils.isStringNullOrEmpty(itemType) ? type !== 'details' : itemType !== 'details' && selectedRequestRefund ? '*' : ''}</Label>
                            <SelectController
                                form={form}
                                isDisabled={(Utils.isStringNullOrEmpty(itemType) ? type === 'details' : itemType === 'details') || (isRefundSavedApprovedOrRefused && Boolean(charge))}
                                placeholder={t('common.responsible')}
                                name="responsibleId"
                                options={responsibleOptions}
                                isClearable={true}
                                rules={{ required: selectedRequestRefund ? true : false }} />
                            {selectedRequestRefund && <InputError error={errors.responsibleId} />}
                        </FormItem>
                    </Col>
                    {shouldDisplay('COST') && <>
                        <Col xs={12} md={6} lg={4}>
                            <FormItem>
                                <Label className={styles.label}>{t('common.cost')} {(Utils.isStringNullOrEmpty(itemType) ? type !== 'details' : itemType !== 'details') && isRequired('COST') ? '*' : ''}</Label>
                                <InputGroupController
                                    text={t('common.euro')}
                                    placeholder={t('common.cost')}
                                    name="cost"
                                    form={form}
                                    disabled={(Utils.isStringNullOrEmpty(itemType) ? type === 'details' : itemType === 'details') || (isRefundSavedApprovedOrRefused && Boolean(charge))}
                                    format="money"
                                    rules={{ required: isRequired('COST') }} />
                                {isRequired('COST') && <InputError error={errors.cost} />}

                                <div className={styles.checkboxArea} data-tip={t('charges.has_fuel_card_message')}>
                                    <Controller
                                        control={control}
                                        name={'requestRefund'}
                                        render={({ value }) => {
                                            return (
                                                <CheckBox
                                                    onChange={e => {
                                                        setValue('requestRefund', e.target.checked);
                                                        onchangeRequestRefund(e.target.checked);
                                                    }}
                                                    label={t('charges.request_refund')}
                                                    checked={value ? true : false}
                                                    disabled={(Utils.isStringNullOrEmpty(itemType) ? type === 'details' : itemType === 'details') || blockRefundTreated || refundHistory.length > 0}
                                                />
                                            );
                                        }}
                                        defaultValue={form.getValues('requestRefund') ? true : false} />
                                </div>
                                {(blockRefundTreated || ((form.getValues('fuelCard') ?? '').length > 0)) && <ReactTooltip />}
                            </FormItem>
                        </Col>
                        <Col xs={12} md={6} lg={4}>
                            <FormItem>
                                <Label className={styles.label}>
                                    {t('maintenances.payment_date')}
                                </Label>
                                <DateTimePickerControllerNew
                                    form={form}
                                    placeholderText={t('common.date')}
                                    name="paymentDate"
                                    autoComplete='off'
                                    disabled={(Utils.isStringNullOrEmpty(itemType) ? type === 'details' : itemType === 'details') || (isRefundSavedApprovedOrRefused && Boolean(charge))}
                                    rules={{ required: false }}
                                />
                                <InputError error={errors.paymentDate} />
                            </FormItem>
                        </Col>
                    </>}

                    {shouldDisplay('QTY') && <Col xs={12} md={6} lg={4} key={'chargeQtdFuel' + reRender}>
                        <FormItem>
                            <Label className={styles.label}>{t((fuelOptions.find(x => x.value == form.getValues(`fuelId`))?.fullLabel == FUELS.ELECTRIC ? 'common.kwh' : 'common.liters') as any)} {(Utils.isStringNullOrEmpty(itemType) ? type !== 'details' : itemType !== 'details') && isRequired('QTY') ? '*' : ''}</Label>
                            <InputGroupController
                                text={t((fuelOptions.find(x => x.value == form.getValues(`fuelId`))?.fullLabel == FUELS.ELECTRIC ? 'common.kwh' : 'common.lt') as any)}
                                placeholder={t((fuelOptions.find(x => x.value == form.getValues(`fuelId`))?.fullLabel == FUELS.ELECTRIC ? 'common.kwh' : 'common.liters') as any)}
                                name="liters"
                                form={form}
                                disabled={(Utils.isStringNullOrEmpty(itemType) ? type === 'details' : itemType === 'details') || (isRefundSavedApprovedOrRefused && Boolean(charge))}
                                format="money"
                                rules={{ required: isRequired('QTY') }} />
                            {isRequired('QTY') && <InputError error={errors.liters} />}
                        </FormItem>
                    </Col>}
                    {shouldDisplay('KMS') && showField(SEGMENT_FEATURES.KM) && <Col xs={12} md={6} lg={4}>
                        <FormItem>
                            <Label className={styles.label}>{t('common.kilometers')} {(Utils.isStringNullOrEmpty(itemType) ? type !== 'details' : itemType !== 'details') ? '*' : ''}</Label>
                            <InputGroupController
                                text={t('common.kms')}
                                placeholder={t('common.kilometers')}
                                name="kilometers"
                                form={form}
                                disabled={(Utils.isStringNullOrEmpty(itemType) ? type === 'details' : itemType === 'details') || (isRefundSavedApprovedOrRefused && Boolean(charge))}
                                type="number"
                                format="money"
                                noFixedDecimalCase={true}
                                rules={{ validate: v => (v != null && !isNaN(v) && v > 0) || (t('common.errors.min_value_greater_than_0') as string) }}
                                onChange={() => compareKms()} />
                            <InputError error={errors.kilometers} />
                            {vehicle && ((type !== 'details' && !isVehicle && getValues('vehicleId')) || (itemType !== 'details' && isVehicle)) && <InputInfoWarning isWarning={inputKmsBelowCurrentVehicleKms} message={t((inputKmsBelowCurrentVehicleKms ? 'common.inserted_kms_below_current_kms' : 'common.insert_kms_below_current_kms'), { kms: Utils.numberFormatter(vehicle?.currentKilometers ?? 0) })} />}
                            {hasReadGPSKmsPolicy && vehicle && currentKms != null && ((type !== 'details' && !isVehicle && getValues('vehicleId')) || (itemType !== 'details' && isVehicle)) && <InputInfoWarning isWarning={false} message={t('location.current_km', { kms: Utils.numberFormatter(currentKms ?? 0) })} />}
                        </FormItem>
                    </Col>}

                    {showField(SEGMENT_FEATURES.HOURS) && <Col xs={12} md={6} lg={4}>
                        <FormItem>
                            <Label className={styles.label}>{t('common.hours')}</Label>
                            <InputGroupController
                                text={t('common.hours_symbol')}
                                placeholder={t('common.hours')}
                                name="hours"
                                form={form}
                                disabled={(Utils.isStringNullOrEmpty(itemType) ? type === 'details' : itemType === 'details') || (isRefundSavedApprovedOrRefused && Boolean(charge))}
                                type="number"
                                format="number"
                                rules={{ required: false, min: { value: 0, message: t('common.errors.min_value_0') } }} />
                            <InputError error={errors.hours} />
                            {vehicle && !!vehicle?.currentHours && ((type !== 'details' && !isVehicle && getValues('vehicleId')) || (itemType !== 'details' && isVehicle)) && <InputInfoWarning isWarning={(form.watch('hours') ?? 0) < (vehicle?.currentHours ?? 0)} message={t(((form.watch('hours') ?? 0) < (vehicle?.currentHours ?? 0) ? 'common.inserted_hours_below_current_hours' : 'common.insert_hours_below_current_hours'), { hours: Utils.numberFormatter(vehicle?.currentHours ?? 0) })} />}
                        </FormItem>
                    </Col>}

                </Row>
                <Row className={styles.filesHeader}>
                    <Label className={styles.label}>{t('common.add_file')}</Label>
                </Row>

                <Row className={styles.filesContent}>
                    <Col xl={12}>
                        <FormItem>
                            <FileSelector
                                isDetails={(Utils.isStringNullOrEmpty(itemType) ? type === 'details' : itemType === 'details') || (isRefundSavedApprovedOrRefused && Boolean(charge))}
                                isMulti={true}
                                initialFiles={getValues('chargeAttachments')}
                                onFilesChanged={setValuesFiles}
                                onRemoveFile={onRemoveFile}
                                label={<Label className={styles.label}>{t('common.add_new_file')} {attachmentsRequired ? '*' : ''}</Label>}
                                smallButtonAdd={true}
                            />
                        </FormItem>
                    </Col>
                    <Col xl={8}>
                        <FormItem>
                            <Label className={styles.label}>{t('charges.notes')}</Label>
                            <InputResizableController
                                name="notes"
                                form={form as any}
                                placeholder={t('charges.notes')}
                                disabled={(Utils.isStringNullOrEmpty(itemType) ? type === 'details' : itemType === 'details') || (isRefundSavedApprovedOrRefused && Boolean(charge))}
                                rows={1}
                            />
                        </FormItem>
                    </Col>

                </Row>

                { hasReadCostCenterPolicy && <Row>
                    <ChargeGeofenceForm
                        form={form}
                        geofences={geofences}
                        geofencesOptions={geofencesOptions}
                        isDetails={(Utils.isStringNullOrEmpty(itemType) ? type === 'details' : itemType === 'details') || (isRefundSavedApprovedOrRefused && Boolean(charge))}
                    />
                </Row>}

            </>
        );
    }

    const renderButtons = () => {
        const showButtonBasedOnPolicy = (Utils.isStringNullOrEmpty(itemType) ? type !== 'details' : itemType !== 'details') && hasChargesWritePolicy;
        const showEditOrRemoveButton = (Utils.isStringNullOrEmpty(itemType) ? type === 'details' : itemType === 'details') && hasChargesWritePolicy && !(charge?.vehicleId && !charge?.vehicleActive) && charge?.active;

        return (
            <>
                <div className={styles.buttonsContainer}>
                    <Button
                        preset={'secondary'}
                        type="button"
                        onClick={() => {
                            if (!!charge) { reset(charge); }
                            (isVehicle || isDriver) ? onBackList() : history.goBack()
                        }}
                        text={t('common.cancel')}
                    />
                    {showEditOrRemoveButton &&
                        <Button
                            type="button"
                            text={t('common.remove')}
                            preset={'danger'}
                            onClick={() => showRemoveItemDialog({ id: charge?.id } as ChargeDto)} />
                    }
                    {showEditOrRemoveButton &&
                        <Button
                            type={'button'}
                            text={t('common.edit')}
                            onClick={() => {
                                if (Utils.isStringNullOrEmpty(tabId)) {
                                    history.push(`/charges/edit/${itemId}`);
                                } else {
                                    history.push(`/${isDriver ? 'drivers' : 'vehicles'}/details/${isDriver ? driverId : vehicleId}/${tabId}/edit/${itemId}`);
                                }
                            }}
                        />}
                    {showButtonBasedOnPolicy &&
                        <Button
                            type={'submit'}
                            text={t('common.save')}
                        />}

                    <QuestionYesNo message={t('common.messages.remove_record')}
                        isVisible={dialogDeleteItemIsOpen}
                        onYes={() => removeItem()}
                        onNo={() => setDialogDeleteItemIsOpen(false)} />
                </div>
            </>
        );
    };

    const renderSideInfo = () => {
        return (
            <>
                <div className={styles.scrollable}>
                    <div>
                        <Label className={styles.subtitle}>{t('charges.refund')}</Label>

                        {refundHistory.length > 0 && <>
                            <div style={{ display: 'flex', justifyContent: 'left', marginBottom: '1.5rem' }}>
                                <TimeLine items={refundHistory} />
                            </div>
                            <div className={styles.divider} />
                        </>}

                        <Row>
                            <Col xl={12}>
                                <FormItem>
                                    <Label className={styles.label}>{t('charges.request_status')}</Label>
                                    <Controller
                                        render={({ onChange, value, ref }) => {
                                            return (
                                                <Select
                                                    options={demandStatusOptions}
                                                    isDisabled={refundPayed || !hasWriteRefundStatusPolicy || (Utils.isStringNullOrEmpty(itemType) ? type === 'details' : itemType === 'details')}
                                                    placeholder={t('charges.request_status')}
                                                    onChange={(data: SelectValueGenericTypeDto) => {
                                                        onChange(data?.value);
                                                        if (data?.value === RequestStatusType.APPROVED) {
                                                            form.setValue('refund.situation', SituationType.NOT_TREATED);
                                                            setSelectedRefundTreated(false);
                                                            return;
                                                        }
                                                        form.setValue('refund.situation', null);
                                                    }}
                                                    ref={ref}
                                                    value={demandStatusOptions.find(x => x.value === value) ? { label: demandStatusOptions.find(x => x.value === value)?.label ?? '', value: value } : null}
                                                />
                                            );
                                        }}
                                        control={control}
                                        name="refund.status"
                                        defaultValue={getValues('refund.status')} />
                                </FormItem>
                            </Col>


                            {form.watch('refund.status') == RequestStatusType.APPROVED &&
                                <>
                                    <Col xl={12}>
                                        <FormItem>
                                            <Label className={styles.label}>{t('charges.situation')}</Label>
                                            <Controller
                                                render={({ ref }) => {
                                                    return (
                                                        <div ref={ref} className={(Utils.isStringNullOrEmpty(itemType) ? type !== 'details' : itemType !== 'details') ? styles.situation : styles.situationDetails}>
                                                            <div onClick={() => (hasWriteRefundSituationPolicy && (Utils.isStringNullOrEmpty(itemType) ? type !== 'details' : itemType !== 'details')) ? onSelectRefundTreated(true, SituationType.TREATED) : null} style={{ width: '50%' }}>
                                                                <div className={styles.labelContainer}>
                                                                    <div className={selectedRefundTreated == true ? styles.selected : styles.notSelected} style={{ background: selectedRefundTreated == true ? (ChargesStatusColorEnum as any)[SituationType.TREATED] : null }}>
                                                                        <span>{t(('charges.situations.' + SituationType.TREATED) as any)}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div onClick={() => (hasWriteRefundSituationPolicy && (Utils.isStringNullOrEmpty(itemType) ? type !== 'details' : itemType !== 'details')) ? onSelectRefundTreated(false, SituationType.NOT_TREATED) : null} style={{ width: '50%' }}>
                                                                <div className={styles.labelContainer}>
                                                                    <div className={selectedRefundTreated == false ? styles.selected : styles.notSelected} style={{ background: selectedRefundTreated == false ? (ChargesStatusColorEnum as any)[SituationType.NOT_TREATED] : null }}>
                                                                        <span>{t(('charges.situations.' + SituationType.NOT_TREATED) as any)}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    );
                                                }}
                                                control={control}
                                                name="refund.situation"
                                                defaultValue={getValues('refund.situation')}
                                            />
                                        </FormItem>
                                    </Col>
                                    <Col xl={12}>
                                        {selectedRefundTreated == true && <FormItem>
                                            <Label className={styles.label}>{t('charges.refund_date')}</Label>
                                            <DateTimePickerController
                                                form={form}
                                                placeholderText={t('common.date')}
                                                onChange={(date: Date) => {
                                                    setValue('refund.dateRefundTreated', date);
                                                }}
                                                dateFormat={DATE_FORMAT_DEFAUT}
                                                customInput={<InputGroup icon={<FaCalendarAlt />} />}
                                                name="refund.dateRefundTreated"
                                                autoComplete='off'
                                                disabled={!hasWriteRefundSituationPolicy || (Utils.isStringNullOrEmpty(itemType) ? type === 'details' : itemType === 'details')}
                                                rules={{ required: true }}
                                            />
                                            <InputError error={errors.refund?.dateRefundTreated} />
                                        </FormItem>}
                                    </Col>
                                </>
                            }
                            {(Utils.isStringNullOrEmpty(itemType) ? type !== 'details' : itemType !== 'details') && !!form.watch('refund.status') && <Col xl={12}>
                                <FormItem>
                                    <Label className={styles.label}>{t('charges.observations')}</Label>
                                    <InputResizableController
                                        key={'refundObservations' + reRender}
                                        name="refund.observations"
                                        form={form as any}
                                        placeholder={t('charges.observations')}
                                        disabled={(Utils.isStringNullOrEmpty(itemType) ? type === 'details' : itemType === 'details')}
                                        rows={3}
                                    />
                                </FormItem>
                            </Col>}

                            {(Utils.isStringNullOrEmpty(itemType) ? type !== 'details' : itemType !== 'details') && !!form.watch('refund.status') &&
                                <Col xl={12} >
                                    <FileSelector
                                        isDetails={(Utils.isStringNullOrEmpty(itemType) ? type === 'details' : itemType === 'details')}
                                        isMulti={true}
                                        initialFiles={getValues('refundAttachments')}
                                        onFilesChanged={setValuesRefundFiles}
                                        onRemoveFile={onRemoveFile}
                                        label={<Label className={styles.label}>{t('common.add_new_file')}</Label>}
                                        smallButtonAdd={true}
                                        fileButtonSizes={{ sm: 0, md: 0, lg: 0, xl: 0 }}
                                    />
                                </Col>}

                        </Row>
                    </div>
                </div>
            </>
        );
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)} className={styles.fullHeight} key={'form-' + refreshKey}>
            {(isVehicle || isDriver) &&
                <div {...props} className={styles.fullHeight}>
                    <Row className={styles.fullHeight} style={{ margin: 0 }}>
                        <Col xs={12} sm={12} md={12} lg={8} xl={9}>
                            <div className={styles.content}>
                                <div className={styles.header}>
                                    <img src={IconBack} className={styles.icon} onClick={() => {
                                        if (!!charge) { reset(charge); }
                                        onBackList()
                                    }} /> {t('charges.title')}
                                </div>
                                <div>
                                    {renderBody()}
                                </div>
                            </div>
                            <Row>
                                {renderButtons()}
                            </Row>
                        </Col>
                        {!blockRefundTreated && selectedRequestRefund && hasReadRefundPolicy &&
                            <Col xs={12} sm={12} md={12} lg={4} xl={3}
                                className={styles.colRightContent}>
                                {renderSideInfo()}
                            </Col>
                        }
                    </Row>
                </div>

            }

            {(!isVehicle && !isDriver) &&
                <ScreenTitle title={t('charges.title')}>
                    <CompactPageLayout
                        title={`${getHeaderTitle() as string}${(Boolean(charge) && !charge?.active) ? ' - ' + t('charges.charge_deleted') : ''}`}
                        onBack={() => navigateTo()}
                        contentAreaClassName={styles.contentArea}
                    >
                        <Box className={styles.box}>
                            <div>
                                <Row>
                                    <Col xs={12} sm={12} md={12} lg={8} xl={9}>
                                        {renderBody()}
                                    </Col>

                                    {!blockRefundTreated && selectedRequestRefund && hasReadRefundPolicy && <Col xs={12} sm={12} md={12} lg={4} xl={3}
                                        className={styles.colRightContent}>
                                        {renderSideInfo()}
                                    </Col>}
                                </Row>
                            </div>

                            <Row>
                                {renderButtons()}
                            </Row>
                        </Box>
                    </CompactPageLayout>
                </ScreenTitle >
            }

            {/* Task #66078/#66220: justificação exigida para gravar uma despesa com avisos de validação. */}
            <ChargeValidationJustifyModal
                isOpen={!!justificationModal}
                rows={justificationModal ? [{ line: 0, warnings: justificationModal.warnings }] : []}
                title={t('charges.validation.title') as string}
                subtitle={t('charges.validation.subtitle') as string}
                confirmText={t('charges.validation.save_anyway') as string}
                cancelText={t('charges.validation.fix_now') as string}
                showLineHeaders={false}
                initialJustifications={justificationModal ? { 0: justificationModal.savedJustification } : undefined}
                onCancel={() => { justificationModal?.cancel(); setJustificationModal(null); }}
                onConfirm={justificationsByLine => { justificationModal?.submit(justificationsByLine[0] ?? ''); setJustificationModal(null); }}
            />

        </form >
    );
}

export default ChargeScreen;